<template>
    <div class="wrapper ">
        Documents !
    </div>
</template>

<script>
    export default {
        name: "Documents"
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Documents.vue